import {ComponentProps, ComponentType, memo} from "react";

export const memoGeneric = memo as <T extends ComponentType<any>>(
    Component: T,
    propsAreEqual?: (
        prevProps: Readonly<ComponentProps<T>>,
        nextProps: Readonly<ComponentProps<T>>
    ) => boolean
) => T;
